<template>
  <div class="app-router">
    <router-link class="btn btn-md btn-success" :to="'/seller/pembelian'">&laquo; Kembali</router-link>
    <v-layout v-resize="onResize" column>
      <v-card id="panel-invoice" :loading="loading" elevation="0" outlined flat tile class="mb-5">
        <v-card-subtitle class="pa-0" v-if="data">
          <div class="d-flex justify-end pa-3">
            <v-btn
              color="success"
              elevation="2"
              dark
              min-width="140"
              :disabled="!data"
              :class="(isMobile) ? 'v-btn--block v-size--default' : 'v-size--small'"
              @click="handlePrint"
            >
              <v-icon color="white darken-1" small class="mr-2">mdi-printer</v-icon>
              <strong class="text-capitalize text-subtitle-2 font-weight-bold">Cetak</strong>
            </v-btn>
          </div>
          <hr />
        </v-card-subtitle>

        <v-card-text class="px-5" v-if="data">
          <div id="section-to-print">
            <div class="d-flex justify-end py-5 my-2 align-center justify-center">
              <!-- <v-img
                width="220"
                max-width="220"
                src="/assets/icons/logo_loginblck.png"
                class="head-logo-1"
              ></v-img>-->
            </div>

            <template v-if="paramId.split('-')[0] === 'trx'">
              <div class="d-block py-5 black--text">
                <v-row>
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Tanggal</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="9"
                    class="pl-0 pb-0 pt-1"
                  >{{ formatDateText(data.trx_status_created_datetime, 'DD MMMM YYYY') }}</v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Pembayaran</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="9"
                    class="pl-0 pb-0 pt-1 text-capitalize"
                  >{{ (data.trx_payment_text.payment_text)}}</v-col>
                </v-row>
              </div>

              <div class="d-block py-0 black--text">
                <v-card elevation="0" outlined flat shaped tile class="card-darker mb-5">
                  <v-card-title class="py-2">
                    <div class="text-subtitle-1 font-weight-bold">Ringkasan Pembayaran</div>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="py-5">
                    <div class="text-subtitle-2">Total Belanja</div>
                    <div
                      class="d-flex"
                      :class="(isMobile) ? 'flex-column justify-start' : 'flex-row align-center justify-space-between'"
                    >
                      <span
                        class="font-weight-bold"
                      >- {{ data.trx_store_name }} ({{ data.trx_code }})</span>
                      <span
                        :class="(isMobile) ? 'd-block text-subtitle-1 text-left mt-2 font-weight-bold black--text' : 'text-right'"
                      >{{ data.trx_bill | toRupiah }}</span>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="py-0">
                    <v-row justify="space-between" class="px-2">
                      <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                        <span class="d-block text-subtitle-2 font-weight-bold">Subtotal Belanja</span>
                      </v-col>
                      <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                        <span
                          class="d-block font-weight-bold"
                          :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                        >{{ data.trx_bill | toRupiah }}</span>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>

                <v-row>
                  <v-col cols="6" v-if="!isMobile"></v-col>
                  <v-col cols="12" sm="6">
                    <v-card elevation="0" outlined flat shaped tile class="card-darker">
                      <v-card-title class="py-1">
                        <v-row justify="space-between">
                          <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold dark--text"
                            >Total Bayar</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                            <span
                              class="d-block font-weight-bold dark--text"
                              :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                            >{{ data.trx_bill | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <br />
              <v-divider class="mt-5 mb-2"></v-divider>
              <v-divider class="mb-5"></v-divider>
              <br />

              <div class="d-block py-0 black--text">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-img
                      width="130"
                      max-width="130"
                      src="/assets/icons/logo_loginblck.png"
                      class="head-logo-2"
                    ></v-img>
                    <div
                      class="d-flex text-subtitle-1 font-weight-bold mt-3"
                      :class="(isMobile) ? 'flex-column' : 'flex-row'"
                    >
                      <span class="pr-3" :class="{'d-block': isMobile}">Nomor Invoice :</span>
                      <span
                        class="dark--text"
                        :class="{'d-block mb-3': isMobile}"
                      >{{ data.trx_code }}</span>
                    </div>
                    <div class="d-block">Diterbitkan atas nama :</div>
                    <v-row>
                      <v-col cols="4" sm="3" class="pb-0 font-weight-bold">Penjual</v-col>
                      <v-col cols="8" sm="9" class="pb-0">{{ data.trx_store_name }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="3" class="py-0 font-weight-bold">Tanggal</v-col>
                      <v-col
                        cols="8"
                        sm="9"
                        class="py-0"
                      >{{ formatDateText(data.trx_status_created_datetime, 'DD MMMM YYYY') }}</v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="1" v-if="!isMobile"></v-col>
                  <v-col cols="12" sm="5" v-if="data.trx_shipping_method == 'courier'">
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold">
                      <span class="pr-3">Tujuan Pengiriman :</span>
                    </div>
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
                      <span class="pr-3">{{ data.trx_buyer_user_name }}</span>
                    </div>
                    <div class="text-caption pr-5">
                      {{ data.user_address_detail }}
                      <br />
                      {{ data.user_address_subdistrict_name }}
                      {{ data.user_address_city_name }}
                      {{ data.user_address_zipcode }}
                      <br />
                      {{ data.user_address_province_name }}
                      <br />
                      {{ data.trx_buyer_user_mobilephone }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="5" v-else>
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold">
                      <span class="pr-3">Pembeli :</span>
                    </div>
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
                      <span
                        class="pr-3"
                      >{{ data.trx_buyer_user_name }} ({{ data.trx_buyer_user_mobilephone }})</span>
                    </div>
                    <div class="d-flex mt-2 flex-row text-subtitle-2 font-weight-bold">
                      <span class="pr-3">Tanggal Pengambilan :</span>
                    </div>
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
                      <span class="pr-3">{{ data.trx_pick_up_date | tanggal }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-divider class="mb-5 my-5"></v-divider>

                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr class="mb-2" v-if="!isMobile">
                        <th class="text-left">
                          <div class="text-subtitle-2 font-weight-bold">Supplier</div>
                        </th>
                        <th class="text-left" width="40%">
                          <div class="text-subtitle-2 font-weight-bold">Nama Produk</div>
                        </th>
                        <th class="text-center">
                          <div class="text-subtitle-2 font-weight-bold">Jumlah</div>
                        </th>
                        <th class="text-center" width="15%">
                          <div class="text-subtitle-2 font-weight-bold">Berat</div>
                        </th>
                        <th class="text-right" width="20%">
                          <div class="text-subtitle-2 font-weight-bold">Harga Barang</div>
                        </th>
                        <th class="text-right" width="20%">
                          <div class="text-subtitle-2 font-weight-bold">Subtotal</div>
                        </th>
                      </tr>
                      <tr class="mb-2" v-else>
                        <th class="text-left">
                          <div class="text-subtitle-2 font-weight-bold">Info Produk</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="data.trx_detail.length > 0">
                        <template v-if="!isMobile">
                          <template v-for="(item, idx) in data.trx_detail">
                            <tr :key="idx">
                              <td class="text-left">
                                <span
                                  class="d-block text-subtitle-2 font-weight-bold"
                                >{{ item.product_supplier_name }}</span>
                              </td>
                              <td class="text-left">
                                <span
                                  class="d-block text-subtitle-2 font-weight-bold"
                                >{{ item.trx_detail_product_code }} - {{ item.trx_detail_product_name }}</span>
                              </td>
                              <td class="text-center">{{ item.trx_detail_quantity }}</td>
                              <td class="text-center">{{ item.trx_detail_product_weight | toKg }}</td>
                              <td class="text-right">
                                {{ item.trx_detail_product_price | toRupiah }}
                                <span
                                  v-if="parseInt(item.po_detail_product_discount_nominal)>0"
                                >
                                  <br />
                                  <small style="color:red">
                                    <strike>{{ item.po_detail_product_price_gross | toRupiah }}</strike>
                                  </small>
                                </span>
                              </td>
                              <td
                                class="text-right"
                              >{{ (item.trx_detail_product_price * item.trx_detail_quantity) | toRupiah }}</td>
                            </tr>
                          </template>
                        </template>

                        <template v-else>
                          <template v-for="(item, idx) in data.trx_detail">
                            <tr :key="idx">
                              <td class="text-left">
                                <span
                                  class="d-block text-subtitle-2 font-weight-bold mt-2"
                                >{{ item.trx_detail_product_code }} - {{ item.trx_detail_product_name }}</span>
                                <span class="d-block text-caption font-weight-normal">
                                  Jumlah :
                                  <strong
                                    class="text-subtitle-2"
                                  >{{ item.trx_detail_quantity }}</strong>
                                </span>
                                <span class="d-block text-caption font-weight-normal">
                                  Berat :
                                  <strong
                                    class="text-subtitle-2"
                                  >{{ item.trx_detail_product_weight | toKg }}</strong>
                                </span>
                                <span class="d-block text-caption font-weight-normal">
                                  Harga :
                                  <strong
                                    class="text-subtitle-2"
                                  >{{ item.trx_detail_product_price | toRupiah }}</strong>
                                </span>
                                <v-divider class="my-3"></v-divider>
                                <span
                                  class="d-block text-subtitle-2 font-weight-normal text-right"
                                >Subtotal :</span>
                                <span
                                  class="d-block text-subtitle-2 font-weight-normal text-right mb-2"
                                >
                                  <strong>{{ (item.trx_detail_product_price * item.trx_detail_quantity) | toRupiah }}</strong>
                                </span>
                              </td>
                            </tr>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <tr>
                          <td
                            :colspan="(isMobile) ? 1 : 6"
                            class="pa-5 text-center"
                          >Tidak ada data barang yang dapat ditampilkan.</td>
                        </tr>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th :colspan="(isMobile) ? 1 : 6" class="pb-0">
                          <v-divider></v-divider>
                        </th>
                      </tr>
                      <tr>
                        <th :colspan="(isMobile) ? 1 : 6" class="text-right py-0">
                          <div
                            class="d-flex align-center justify-end black--text"
                            :class="(isMobile) ? 'flex-column' : 'flex-row'"
                          >
                            <span
                              class="text-subtitle-1"
                              :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block font-weight-bold pr-5 mr-5'"
                            >Subtotal Harga Barang</span>
                            <span
                              class="text-subtitle-1 font-weight-bold text-right"
                              :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block pl-5 ml-5'"
                            >{{ data.trx_price_total | toRupiah }}</span>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th :colspan="(isMobile) ? 1 : 6" class="pb-0">
                          <v-divider></v-divider>
                        </th>
                      </tr>
                    </tfoot>
                  </template>
                </v-simple-table>

                <v-row>
                  <v-col cols="6" v-if="!isMobile"></v-col>
                  <v-col cols="12" sm="6">
                    <v-card elevation="0" outlined flat shaped tile>
                      <!-- <v-card-title class="py-2">
                        <v-row justify="space-between">
                          <v-col
                            cols="12"
                            sm="6"
                            class="py-2"
                            :class="{'text-right pb-0': isMobile}"
                          >
                            <span class="d-block text-caption">Kode Unik</span>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-2">
                            <span
                              class="d-block text-caption font-weight-bold text-right"
                            >{{ data.trx_price_unique | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <hr />-->
                      <v-card-title class="py-2" v-if="data.trx_shipping_method == 'courier'">
                        <v-row justify="space-between">
                          <v-col
                            cols="12"
                            sm="6"
                            class="py-2"
                            :class="{'text-right pb-0': isMobile}"
                          >
                            <span
                              class="d-block text-caption"
                            >{{ (data.trx_courier_code) ? data.trx_courier_code.toUpperCase() : '' }} - {{ data.trx_courier_service }} ({{ grandWeightTotal | toKg }})</span>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-2">
                            <span
                              class="d-block text-caption font-weight-bold text-right"
                            >{{ data.trx_price_shipping | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <hr />
                      <v-card-title class="py-2" v-if="data.trx_shipping_method == 'courier'">
                        <v-row justify="space-between">
                          <v-col
                            cols="12"
                            sm="6"
                            class="py-2"
                            :class="{'text-right pb-0': isMobile}"
                          >
                            <span
                              class="d-block text-subtitle-2 font-weight-bold black--text"
                            >Subtotal Ongkos Kirim</span>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-2">
                            <span
                              class="d-block text-subtitle-2 font-weight-bold black--text text-right"
                            >{{ (parseFloat(data.trx_price_shipping) + parseFloat(data.trx_price_unique)) | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" v-if="!isMobile"></v-col>
                  <v-col cols="12" sm="6">
                    <v-card elevation="0" outlined flat shaped tile class="card-darker">
                      <v-card-title class="py-1">
                        <v-row justify="space-between">
                          <v-col cols="12" sm="6" :class="{'text-right pb-0': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold black--text"
                            >Total Bayar</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <span
                              class="d-block font-weight-bold black--text text-right"
                              :class="(isMobile) ? 'text-h5' : 'text-subtitle-1'"
                            >{{ data.trx_bill | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template v-else-if="paramId.split('-')[0] === 'po'">
              <div class="d-block py-5 black--text">
                <v-row>
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Tanggal</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="4"
                    class="pl-0 pb-0 pt-1"
                  >{{ formatDateText(data.po_status_created_datetime, 'DD MMMM YYYY') }}</v-col>
                  <v-col cols="6" sm="1" class="pb-0 pt-1">
                    <span class="font-weight-bold" style="margin-right:10px;">Status</span>
                  </v-col>
                  <v-col cols="6" sm="4" class="pl-0 pb-0 pt-1">
                    <v-chip
                      small
                      label
                      :class="colorStatus(data.po_status)"
                    >{{ statusCaption(data.po_status) }}</v-chip>
                  </v-col>
                </v-row>

                <v-row v-if="data.po_payment_method!='midtrans'">
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Pembayaran</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="9"
                    class="pl-0 pb-0 pt-1 text-capitalize"
                  >{{ (data.po_payment_method) ? data.po_payment_method.replace('_', ' ') : '-' }}</v-col>
                </v-row>
                <v-row v-if="data.po_payment_method=='midtrans'">
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Pembayaran</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="9"
                    class="pl-0 pb-0 pt-1 text-capitalize"
                  >{{ data.po_payment_text.payment_text }}</v-col>
                </v-row>
                <v-row v-if="data.po_payment_method=='midtrans'">
                  <v-col cols="6" sm="2" class="pb-0 pt-1">
                    <strong>Kode Pembayaran</strong>
                  </v-col>
                  <v-col
                    cols="6"
                    sm="9"
                    class="pl-0 pb-0 pt-1 text-capitalize"
                  >{{ data.trx_midtrans_payment_code }}</v-col>
                </v-row>
              </div>

              <div class="d-block py-0 black--text">
                <v-card elevation="0" outlined flat shaped tile class="card-darker mb-5">
                  <v-card-title class="py-2">
                    <div class="text-subtitle-1 font-weight-bold">Ringkasan Pembayaran</div>
                  </v-card-title>
                  <v-divider></v-divider>
                  <v-card-text class="py-5">
                    <div class="text-subtitle-2">Total Belanja</div>
                    <div
                      class="d-flex"
                      :class="(isMobile) ? 'flex-column justify-start' : 'flex-row align-center justify-space-between'"
                    >
                      <span class="font-weight-bold">- {{ data.po_store_name }} ({{ data.po_code }})</span>
                      <span
                        :class="(isMobile) ? 'd-block text-subtitle-1 text-left mt-2 font-weight-bold black--text' : 'text-right'"
                      >{{ data.po_price_grand_total | toRupiah }}</span>
                    </div>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions class="py-0">
                    <v-row justify="space-between" class="px-2">
                      <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                        <span class="d-block text-subtitle-2 font-weight-bold">Subtotal Belanja</span>
                      </v-col>
                      <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                        <span
                          class="d-block font-weight-bold"
                          :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                        >{{ data.po_price_grand_total | toRupiah }}</span>
                      </v-col>
                    </v-row>
                  </v-card-actions>
                </v-card>

                <v-row>
                  <v-col cols="6" v-if="!isMobile"></v-col>
                  <v-col cols="12" sm="6">
                    <v-card elevation="0" outlined flat shaped tile class="card-darker">
                      <v-card-title class="py-1">
                        <v-row justify="space-between">
                          <v-col cols="12" sm="6" :class="{'pb-1 text-right': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold dark--text"
                            >Total Bayar</span>
                          </v-col>
                          <v-col cols="12" sm="6" :class="{'pt-0 text-right': isMobile}">
                            <span
                              class="d-block font-weight-bold dark--text"
                              :class="(isMobile) ? 'text-subtitle-1' : 'text-subtitle-2 text-right'"
                            >{{ data.po_price_grand_total | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
              </div>

              <br />
              <v-divider class="mt-5 mb-2"></v-divider>
              <v-divider class="mb-5"></v-divider>
              <br />

              <div class="d-block py-0 black--text">
                <v-row>
                  <v-col cols="12" sm="6">
                    <!-- <v-img
                      width="130"
                      max-width="130"
                      src="/assets/icons/logo_loginblck.png"
                      class="head-logo-2"
                    ></v-img>-->
                    <div
                      class="d-flex text-subtitle-1 font-weight-bold mt-3"
                      :class="(isMobile) ? 'flex-column' : 'flex-row'"
                    >
                      <span class="pr-3" :class="{'d-block': isMobile}">Nomor Invoice :</span>
                      <span
                        class="black--text"
                        :class="{'d-block mb-3': isMobile}"
                      >{{ data.po_code }}</span>
                    </div>
                    <div class="d-block">Diterbitkan atas nama :</div>
                    <v-row>
                      <v-col cols="4" sm="3" class="pb-0 font-weight-bold">Penjual</v-col>
                      <v-col cols="8" sm="9" class="pb-0">{{ data.po_store_name }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="4" sm="3" class="py-0 font-weight-bold">Tanggal</v-col>
                      <v-col
                        cols="8"
                        sm="9"
                        class="py-0"
                      >{{ formatDateText(data.po_status_created_datetime, 'DD MMMM YYYY') }}</v-col>
                    </v-row>
                    <template v-if="data.is_dropship=='1'">
                      <v-row>
                        <v-col cols="4" sm="3" class="pb-0 font-weight-bold">Dropship Nama</v-col>
                        <v-col cols="8" sm="9" class="pb-0">{{ data.dropship_store_name }}</v-col>
                      </v-row>
                      <v-row>
                        <v-col cols="4" sm="3" class="pb-0 font-weight-bold">Dropship Telepon</v-col>
                        <v-col cols="8" sm="9" class="pb-0">{{ data.dropship_store_phone }}</v-col>
                      </v-row>
                      <v-row v-if="data.is_dropship_marketplace=='1'">
                        <v-col cols="4" sm="3" class="pb-0 font-weight-bold">Invoice Marketplace</v-col>
                        <v-col cols="8" sm="9" class="pb-0">{{ data.dropship_marketplace_invoice }}</v-col>
                      </v-row>
                      <v-row v-if="data.is_dropship_marketplace=='1'">
                        <v-col cols="4" sm="3" class="pb-0 font-weight-bold">No. Resi Marketplace</v-col>
                        <v-col cols="8" sm="9" class="pb-0">{{ data.dropship_marketplace_resi }}</v-col>
                      </v-row>
                      <v-row v-if="data.is_dropship_marketplace=='1'">
                        <v-col
                          cols="4"
                          sm="3"
                          class="pb-0 font-weight-bold"
                        >Shipping Label Marketplace</v-col>
                        <v-col cols="8" sm="9" class="pb-0">
                          <a
                            :href="data.dropship_marketplace_file_shipping_label"
                            target="_blank"
                          >Shipping Label</a>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                  <v-col cols="1" v-if="!isMobile"></v-col>

                  <v-col cols="12" sm="5" v-if="data.po_shipping_method == 'courier'">
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold">
                      <span class="pr-3">Tujuan Pengiriman :</span>
                    </div>
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
                      <span class="pr-3">{{ data.po_user_name }}</span>
                    </div>
                    <div class="text-caption pr-5">
                      {{ detailStore.store_address }}
                      <br />
                      {{ detailStore.store_subdistrict_name }}
                      {{ detailStore.store_city_name }}
                      {{ detailStore.store_zipcode }}
                      <br />
                      {{ detailStore.store_province_name }}
                      <br />
                      {{ data.po_user_mobilephone }}
                    </div>
                  </v-col>

                  <v-col cols="12" sm="5" v-else>
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold">
                      <span class="pr-3">Tanggal Pengambilan :</span>
                    </div>
                    <div class="d-flex flex-row text-subtitle-2 font-weight-bold mt-1">
                      <span class="pr-3">{{ data.po_pick_up_date | tanggal }}</span>
                    </div>
                  </v-col>
                </v-row>

                <v-divider class="mb-5 my-5"></v-divider>

                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr class="mb-2" v-if="!isMobile">
                        <th class="text-left">
                          <div class="text-subtitle-2 font-weight-bold">Supplier</div>
                        </th>
                        <th class="text-left" width="40%">
                          <div class="text-subtitle-2 font-weight-bold">Nama Produk</div>
                        </th>
                        <th class="text-center">
                          <div class="text-subtitle-2 font-weight-bold">Jumlah</div>
                        </th>
                        <th class="text-center" width="15%">
                          <div class="text-subtitle-2 font-weight-bold">Berat</div>
                        </th>
                        <th class="text-right" width="20%">
                          <div class="text-subtitle-2 font-weight-bold">Harga Barang</div>
                        </th>
                        <th class="text-right" width="20%">
                          <div class="text-subtitle-2 font-weight-bold">Subtotal</div>
                        </th>
                      </tr>
                      <tr class="mb-2" v-else>
                        <th class="text-left">
                          <div class="text-subtitle-2 font-weight-bold">Info Produk</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <template v-if="data.po_detail.length > 0">
                        <template v-if="!isMobile">
                          <template v-for="(item, idx) in data.po_detail">
                            <tr :key="idx">
                              <td class="text-left">
                                <span
                                  class="d-block text-subtitle-2 font-weight-bold"
                                >{{ item.product_supplier_name }}</span>
                              </td>
                              <td class="text-left">
                                <span
                                  class="d-block text-subtitle-2 font-weight-bold"
                                >{{ item.po_detail_product_code }} - {{ item.po_detail_product_name }}</span>
                              </td>
                              <td class="text-center">{{ item.po_detail_quantity_requested }}</td>
                              <td class="text-center">{{ item.po_detail_product_weight | toKg }}</td>
                              <td class="text-right">
                                {{ item.po_detail_product_price | toRupiah }}
                                <span
                                  v-if="parseInt(item.po_detail_product_discount_nominal)>0"
                                >
                                  <br />
                                  <small style="color:red">
                                    <strike>{{ item.po_detail_product_price_gross | toRupiah }}</strike>
                                  </small>
                                </span>
                              </td>
                              <td
                                class="text-right"
                              >{{ (item.po_detail_product_price * item.po_detail_quantity_requested) | toRupiah }}</td>
                            </tr>
                          </template>
                        </template>

                        <template v-else>
                          <template v-for="(item, idx) in data.po_detail">
                            <tr :key="idx">
                              <td class="text-left">
                                <span
                                  class="d-block text-subtitle-2 font-weight-bold mt-2"
                                >{{ item.po_detail_product_code }} - {{ item.po_detail_product_name }}</span>
                                <span class="d-block text-caption font-weight-normal">
                                  Jumlah :
                                  <strong
                                    class="text-subtitle-2"
                                  >{{ item.po_detail_quantity_requested }}</strong>
                                </span>
                                <span class="d-block text-caption font-weight-normal">
                                  Berat :
                                  <strong
                                    class="text-subtitle-2"
                                  >{{ item.po_detail_product_weight | toKg }}</strong>
                                </span>
                                <span class="d-block text-caption font-weight-normal">
                                  Harga :
                                  <strong
                                    class="text-subtitle-2"
                                  >{{ item.po_detail_product_price | toRupiah }}</strong>
                                </span>
                                <v-divider class="my-3"></v-divider>
                                <span
                                  class="d-block text-subtitle-2 font-weight-normal text-right"
                                >Subtotal :</span>
                                <span
                                  class="d-block text-subtitle-2 font-weight-normal text-right mb-2"
                                >
                                  <strong>{{ (item.po_detail_product_price * item.po_detail_quantity_requested) | toRupiah }}</strong>
                                </span>
                              </td>
                            </tr>
                          </template>
                        </template>
                      </template>
                      <template v-else>
                        <tr>
                          <td
                            :colspan="(isMobile) ? 1 : 6"
                            class="pa-5 text-center"
                          >Tidak ada data barang yang dapat ditampilkan.</td>
                        </tr>
                      </template>
                    </tbody>
                    <tfoot>
                      <tr>
                        <th :colspan="(isMobile) ? 1 : 6" class="pb-0">
                          <v-divider></v-divider>
                        </th>
                      </tr>
                      <tr>
                        <th :colspan="(isMobile) ? 1 : 6" class="text-right py-0">
                          <div
                            class="d-flex align-center justify-end black--text"
                            :class="(isMobile) ? 'flex-column' : 'flex-row'"
                          >
                            <span
                              class="text-subtitle-1"
                              :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block font-weight-bold pr-5 mr-5'"
                            >Subtotal Harga Barang</span>
                            <span
                              class="text-subtitle-1 font-weight-bold text-right"
                              :class="(isMobile) ? 'text-right d-flex align-self-end' : 'd-block pl-5 ml-5'"
                            >{{ data.po_price_total | toRupiah }}</span>
                          </div>
                        </th>
                      </tr>
                      <tr>
                        <th :colspan="(isMobile) ? 1 : 6" class="pb-0">
                          <v-divider></v-divider>
                        </th>
                      </tr>
                    </tfoot>
                  </template>
                </v-simple-table>

                <v-row>
                  <v-col cols="6" v-if="!isMobile"></v-col>
                  <v-col cols="12" sm="6">
                    <v-card elevation="0" outlined flat shaped tile>
                      <!-- <v-card-title class="py-2">
                        <v-row justify="space-between">
                          <v-col
                            cols="12"
                            sm="6"
                            class="py-2"
                            :class="{'text-right pb-0': isMobile}"
                          >
                            <span class="d-block text-caption">Kode Unik</span>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-2">
                            <span
                              class="d-block text-caption font-weight-bold text-right"
                            >{{ data.po_price_unique | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <hr />-->
                      <v-card-title class="py-2">
                        <v-row justify="space-between" v-if="data.po_shipping_method == 'courier'">
                          <v-col
                            cols="12"
                            sm="6"
                            class="py-2"
                            :class="{'text-right pb-0': isMobile}"
                          >
                            <span
                              class="d-block text-caption"
                            >{{ (data.po_courier_code) ? data.po_courier_code.toUpperCase() : '' }} - {{ data.po_courier_service }} ({{ grandWeightTotal | toKg }})</span>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-2">
                            <span
                              class="d-block text-caption font-weight-bold text-right"
                            >{{ data.po_price_shipping | toRupiah }}</span>
                          </v-col>
                        </v-row>
                        <v-row justify="space-between" v-else>
                          <v-col
                            cols="12"
                            sm="6"
                            class="py-2"
                            :class="{'text-right pb-0': isMobile}"
                          >
                            <span class="d-block text-caption">Pengambilan di toko</span>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-2">
                            <span
                              class="d-block text-caption font-weight-bold text-right"
                            >{{ data.po_price_shipping | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <hr />
                      <v-card-title class="py-2" v-if="false">
                        <v-row justify="space-between">
                          <v-col
                            cols="12"
                            sm="6"
                            class="py-2"
                            :class="{'text-right pb-0': isMobile}"
                          >
                            <span
                              class="d-block text-subtitle-2 font-weight-bold black--text"
                            >Subtotal Ongkos Kirim</span>
                          </v-col>
                          <v-col cols="12" sm="6" class="py-2">
                            <span
                              class="d-block text-subtitle-2 font-weight-bold black--text text-right"
                            >{{ (parseFloat(data.po_price_shipping) + parseFloat(data.po_price_unique)) | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="6" v-if="!isMobile"></v-col>
                  <v-col cols="12" sm="6">
                    <v-card elevation="0" outlined flat shaped tile class="card-darker">
                      <v-card-title class="py-1">
                        <v-row justify="space-between">
                          <v-col cols="12" sm="6" :class="{'text-right pb-0': isMobile}">
                            <span
                              class="d-block text-subtitle-1 font-weight-bold dark--text"
                            >Total Bayar</span>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <span
                              class="d-block font-weight-bold dark--text text-right"
                              :class="(isMobile) ? 'text-h5' : 'text-subtitle-1'"
                            >{{ data.po_price_grand_total | toRupiah }}</span>
                          </v-col>
                        </v-row>
                      </v-card-title>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row v-if="data.po_payment_method=='midtrans'">
                  <v-col cols="12" sm="12" class="pb-0 pt-1">
                    <span>
                      <i>
                        Note: Silakan klik
                        <a target="_blank" :href="data.po_pdf_url">Link</a> berikut ini untuk petunjuk pembayaran.
                      </i>
                    </span>
                  </v-col>
                </v-row>
              </div>
            </template>
          </div>
        </v-card-text>

        <v-card-text v-else>
          <div
            class="d-flex align-center pa-5 justify-center text-subtitle-2 text-center"
            v-if="!loading"
          >Tidak ada invoice yang sesuai ditemukan.</div>

          <div class="d-flex align-center pa-5 justify-center text-subtitle-2 text-center" v-else>
            <v-progress-circular indeterminate color="green"></v-progress-circular>
          </div>
        </v-card-text>
      </v-card>
    </v-layout>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import moment from "moment";

export default {
  data() {
    return {
      loading: false,
      paramId: false,
      data: null,
      grandWeightTotal: 0,
      isMobile: false
    };
  },
  computed: {
    ...mapState("auth", ["isAuth", "userData"]),
    ...mapState("storeSeller", ["detailStore"]),
    ...mapState("transaksiSeller", ["detailPesanan"]),
    ...mapState("pembelianSeller", ["detailPembelian"])
  },
  methods: {
    statusCaption(status) {
      if (status === "created") return "Belum Dibayar";
      else if (status === "pending") return "Belum Dibayar";
      else if (status === "paid") return "Dibayar";
      else if (status === "processed") return "Dibayar";
      else if (status === "completed") return "Sudah Selesai";
      else if (status === "cancel") return "Dibatalkan";
    },
    colorStatus(status) {
      if (status === "paid") return "green white--text";
      else if (status === "pending") return "orange darken-1 white--text";
      else if (status === "processed") return "blue darken-1 white--text";
      else if (status === "on_delivery")
        return "deep-purple darken-1 white--text";
      else if (status === "completed")
        return "light-green darken-4 white--text";
      else if (status === "cancel") return "red white--text";
    },
    ...mapActions("storeSeller", ["getStoreDetail"]),
    ...mapActions("pembelianSeller", ["getPembelianDetail"]),
    ...mapActions("transaksiSeller", ["getPesananDetail"]),
    handlePrint() {
      window.print();
    },

    formatDateText(params, format) {
      let dates = params ? new Date(params) : null;
      return dates ? moment(dates).format(format) : null;
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },

  async mounted() {
    this.loading = await true;
    await this.getStoreDetail();
    this.paramId = await this.$route.params.id;
    if (this.paramId.split("-")[0] === "trx") {
      await this.getPesananDetail({ id: this.paramId.split("-")[1] });
      this.data = await this.detailPesanan;
      this.grandWeightTotal = this.data.trx_detail.reduce(
        (accumulator, current) =>
          parseFloat(accumulator) +
          parseFloat(
            current.trx_detail_product_weight * current.trx_detail_quantity
          ),
        0
      );
    } else if (this.paramId.split("-")[0] === "po") {
      await this.getPembelianDetail({ po_id: this.paramId.split("-")[1] });
      this.data = await this.detailPembelian;
      this.grandWeightTotal = this.data.po_detail.reduce(
        (accumulator, current) =>
          parseFloat(accumulator) +
          parseFloat(
            current.po_detail_product_weight *
              current.po_detail_quantity_requested
          ),
        0
      );
    }

    this.loading = false;
  },

  created() {
    this.$store.dispatch("setPageTitle", `Invoice`);
  }
};
</script>

<style lang="scss" scoped>
@media (max-width: 599px) {
}
</style>